import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection, Person } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ContactPluginService } from './contact-plugin.service';

@Component({
    templateUrl: './contact.component.html',
    standalone: false
})
export class ContactPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public technicien: Person;
  public regionalServiceManager: Person;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef, private service: ContactPluginService) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.cdRef.detectChanges();
  }

  initData() {
    this.initTechnicien();
  }

  initTechnicien() {
    if (this.plugin.config.TechnicienId) {
      this.service.getPerson(this.plugin.config.TechnicienId).subscribe((person) => {
        this.technicien = person;
      });
    }
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'plugins',
      this.plugin.id,
      'contact',
      'edit'
    ];
  }
}

PluginComponent.plugins['contact'] = ContactPluginComponent;
